/**
 * 内容处理服务
 * 管理不同类型内容（文本、PDF、网页）的处理逻辑
 *
 * 核心功能：
 * 1. 处理器注册与管理（文本、PDF、网页等）
 * 2. 根据内容类型路由到合适的处理器
 * 3. 统一内容处理接口
 * 4. 内容分析和上下文提取
 * 5. 管理处理结果和元数据
 */
/**
 * 内容处理服务
 * 管理并提供对不同类型内容的处理能力
 */
export class ContentProcessorService {
    constructor() {
        // 存储不同类型内容对应的处理器
        this.processors = new Map();
        // Private constructor for singleton
    }
    static getInstance() {
        if (!ContentProcessorService.instance) {
            ContentProcessorService.instance = new ContentProcessorService();
        }
        return ContentProcessorService.instance;
    }
    /**
     * 注册内容处理器
     * @param type 内容类型
     * @param processor 对应的处理器
     */
    registerProcessor(type, processor) {
        this.processors.set(type, processor);
    }
    /**
     * 获取指定类型的内容处理器
     * @param type 内容类型
     * @returns 内容处理器
     * @throws 如果处理器不存在则抛出错误
     */
    getProcessor(type) {
        const processor = this.processors.get(type);
        if (!processor) {
            throw new Error(`不支持的内容类型: ${type}`);
        }
        return processor;
    }
    /**
     * 处理内容
     * @param type 内容类型
     * @param content 原始内容
     * @returns 处理结果
     */
    async processContent(type, content) {
        const processor = this.getProcessor(type);
        const parsedContent = await processor.parseContent(content);
        // 添加额外信息
        const result = {
            ...parsedContent,
        };
        // 添加语言检测（如果处理器支持）
        if (processor.detectLanguage && typeof content === 'string') {
            result.detectedLanguage = processor.detectLanguage(content);
        }
        // 添加文本统计（如果处理器支持）
        if (processor.getTextStats && typeof content === 'string') {
            result.textStatistics = processor.getTextStats(content);
        }
        return result;
    }
    /**
     * 获取内容上下文
     * @param type 内容类型
     * @param paragraphs 段落数据
     * @param selectedText 选中文本
     * @param _contextSize 上下文大小
     * @returns 上下文结果
     */
    getContentContext(type, paragraphs, selectedText, _contextSize = 2) {
        // 已废弃，直接返回空对象或抛出异常
        return { selectedParagraph: null };
    }
}
// Add singleton pattern
ContentProcessorService.instance = null;
//# sourceMappingURL=content-processor.service.js.map